/**
 * Map Block functionality
 * @class
 */
export default class MapsBlock {
    /**
     * @constructor
     * @param {HTMLElement} element The maps block root element
     * @param {DOMStringMap} config The maps config string
     */
    constructor(element, config) {
        var _a;
        this.initialView = { lat: -4.6270824, lng: 54.8737009 };
        this.fitBounds = true;
        this.initialZoomLevel = 3;
        this.config = config;
        this.element = element;
        this.markers = [];
        if (config === null || config === void 0 ? void 0 : config.mapCoordinates) {
            this.initialView = this.getLatLngFromCoordinates(config.mapCoordinates);
        }
        if (config === null || config === void 0 ? void 0 : config.mapFitBounds) {
            this.fitBounds = true;
        }
        if (config === null || config === void 0 ? void 0 : config.mapZoom) {
            this.initialZoomLevel = parseInt(config.mapZoom);
        }
        this.map = this.render();
        if (this.config.mapMarkers && ((_a = this.config.mapMarkers) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            this.addMarkers(this.config.mapMarkers);
        }
        if (this.fitBounds) {
            this.fitToBounds();
        }
    }
    getLatLngFromCoordinates(coordinates) {
        const coordinatesParts = coordinates
            .split(",")
            .map((x) => parseFloat(x));
        return {
            lat: coordinatesParts[0],
            lng: coordinatesParts[1],
        };
    }
    render() {
        this.element.style.height = "100%";
        return new google.maps.Map(this.element, {
            zoom: this.initialZoomLevel,
            center: this.initialView,
            maxZoom: 17,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_CENTER,
            },
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER,
            },
            scaleControl: true,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
        });
    }
    addMarkers(markers) {
        let markersObject;
        if (typeof markers === "string") {
            try {
                markersObject = JSON.parse(markers);
            }
            catch (_a) {
                return [];
            }
        }
        if (markersObject) {
            markersObject.forEach((marker) => {
                const mapMarker = new google.maps.Marker({
                    position: { lat: marker.lat, lng: marker.long },
                    map: this.map,
                });
                if (marker && (marker.Image ||
                    marker.Title ||
                    marker.Description)) {
                    const markerInfoBox = new google.maps.InfoWindow({
                        content: `
                      ${marker.Image || marker.Title || marker.Description
                            ? `
                                <div class="m-card m-card--basic m-card--map" style="max-width: 240px;">
                                    <div class="m-card__image">
                                        ${marker.Image
                                ? `<img src="${marker.Image}"  style="max-width: 100%;" />`
                                : ``}
                                    </div>
                                    <div class="m-card__body m-card__body--has-image">
                                        ${marker.Title
                                ? `
                                            <h3 class="h6 u-text--blue">
                                                    ${marker.Link
                                    ? `<a class="m-card__cover" href="${marker.Link}" target="_parent">`
                                    : ``}
                                                        ${marker.Title}
                                                    ${marker.Link ? `</a>` : ``}
                                            </h3>`
                                : ``}
                                        ${marker.Description
                                ? `<p class="m-card__description">${marker.Description}</p>`
                                : ``}
                                    </div>
                                </div>
                                `
                            : ""}`,
                    });
                    mapMarker.addListener("click", () => {
                        markerInfoBox.open({
                            anchor: mapMarker,
                            map: this.map,
                            shouldFocus: false,
                        });
                    });
                }
                this.markers.push(mapMarker);
            });
            return this.markers;
        }
    }
    fitToBounds() {
        const bounds = new google.maps.LatLngBounds();
        this.markers.forEach((x) => bounds.extend(x.position));
        this.map.fitBounds(bounds);
    }
    /**
     * Creates new instances of IMapsBlockUtils for each `[data-component="Map"]` element.
     */
    static init() {
        const maps = [...document.querySelectorAll('[data-component="Map"]')];
        maps === null || maps === void 0 ? void 0 : maps.forEach(map => {
            setTimeout(() => {
                if (maps) {
                    const mapEl = new MapsBlock(map, Object.assign({}, map.dataset));
                }
            }, 0);
        });
    }
}
